<div class="toast-stack" *transloco="let t" aria-live="polite">
  @for (toast of toasts(); track toast.id) {
    <div
      class="toast"
      role="status"
      [class.toast-leaving]="toast.leaving"
      [attr.data-type]="toast.type"
    >
      <div class="toast-row">
        <!-- 24px status glyph painted in the kind's status colour. -->
        <app-icon
          class="toast-icon"
          aria-hidden="true"
          [name]="statusIcon(toast.type)"
          [size]="24"
        />

        <div class="toast-body">
          <div class="toast-title">{{ toast.title || t('toast.' + toast.type) }}</div>
          <div class="toast-message">{{ toast.message }}</div>
          @if (toast.actions.length > 0) {
            <div class="toast-actions">
              @for (action of toast.actions; track action.label) {
                <button type="button" class="toast-action" (click)="runAction(toast, action)">
                  {{ action.label }}
                </button>
              }
            </div>
          }
        </div>

        <button
          type="button"
          class="toast-close"
          (click)="dismiss(toast.id)"
          [attr.aria-label]="t('toast.close')"
        >
          <app-icon name="icon-x" [size]="24" />
        </button>
      </div>

      <!-- Auto-dismiss countdown, flush at the bottom edge.
           TODO(ds): adopt app-progress-bar once it lands. -->
      @if (toast.duration > 0 && !toast.leaving) {
        <div class="toast-track" aria-hidden="true">
          <div class="toast-bar" [style.animation-duration.ms]="toast.duration"></div>
        </div>
      }
    </div>
  }
</div>
